"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Gallery = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Gallery = function Gallery(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.18 6.204c0-1.807.999-2.79 2.824-2.79h7.9v-.107c0-1.212-.703-1.907-2.015-1.907H2.015C.703 1.4 0 2.089 0 3.39v6.253c0 1.3.703 1.995 1.98 1.995h.2V6.204zM5.11 14.6h8.875c1.312 0 2.015-.695 2.015-1.99v-6.3c0-1.295-.703-1.99-2.015-1.99H5.111c-1.318 0-2.015.695-2.015 1.99v6.294c0 1.301.697 1.996 2.015 1.996zm2.53-5.116A1.367 1.367 0 016.292 8.14c0-.742.62-1.36 1.348-1.36.738 0 1.353.618 1.353 1.36 0 .724-.615 1.343-1.353 1.343zm-2.423 3.768c-.455 0-.744-.277-.744-.748v-.442l1.07-.971c.413-.377.69-.618 1.05-.618.361 0 .668.253 1.094.624l.68.594 1.996-1.784c.508-.453.88-.753 1.312-.753.443 0 .821.294 1.318.753l1.63 1.537v1.06c0 .47-.29.748-.756.748h-8.65z",
    fill: "currentColor"
  }));
};

exports.Gallery = Gallery;
var _default = Gallery;
exports.default = _default;